import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCapture = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M49.899 19.362c-16.824 0-30.546 13.718-30.546 30.543s13.721 30.546 30.546 30.546S80.442 66.73 80.442 49.905 66.724 19.362 49.899 19.362" })
});
export default SvgCapture;
